import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import Table from "../../../../components/table";
import InputSearch from "../../../InputSearch/InputSearch";
import Paperplane from "../../../Loading/Paperplane";

import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as ColumnFilterIcon } from "../../../../build/images/icons/ColumnFilterIcon.svg";

import "./negotiations.css";
import PopoverColumnsFilter from "../../../popovercolumnsfilter/PopoverColumnsFilter";
import { getRankingGroupCall, getRankingGroupCallCsat, getRankingGroupCallEnviadas, getUnitGroupedCall, getUnitUserCall } from "../../../../actions";
import { groupBy } from "../../../../utils/groupBy";
import axios from "axios";

let exhibColumn = [];

export default function Negotiations() {
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const columnsNegotiationsAgent = useSelector(
    (state) => state.columnsNegotiationsAgent
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );

  const [searchData, setSearchData] = useState("");
  const [loadingGroup, setLoadingGroup] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [tabActive, setTabActive] = useState("grupos");
  const [dataTableUser, setDataTableUser] = useState([]);
  const [dataTableGroup, setDataTableGroup] = useState([]);
  const [dataTotalUser, setDataTotalUser] = useState([]);
  const [npsDatasGroup, setNpsDatasGroup] = useState([]);
  const [dataTotalGroup, setDataTotalGroup] = useState([]);
  const [npsDatasUser, setNpsDatasUser] = useState([]);

  useEffect(() => {
    if (!dataTableGroup) return;
  
    async function fetchData() {
      const dataRefactored = await refactorNpsList(dataTableGroup, "group");
      setNpsDatasGroup(dataRefactored);
    }
  
    fetchData();
  }, [dataTableGroup]);

  useEffect(() => {
    if (!dataTableUser) return;
  
    async function fetchData() {
      const dataRefactored = await refactorNpsList(dataTableUser, "user");
      setNpsDatasUser(dataRefactored);
    }
  
    fetchData();
  }, [dataTableUser]);

  let columns = [];

  if(tabActive === "agentes"){
    exhibColumn = [
      {
        title: "Nome",
        exhib: columnsNegotiationsAgent.name,
      },
      {
        title: "NPS",
        exhib: columnsNegotiationsAgent.nps,
      },
      {
        title: "CSAT",
        exhib: columnsNegotiationsAgent.csat,
      },
      {
        title: "Enviadas",
        exhib: false,
      },
      {
        title: "Respondidas",
        exhib: false,
      },
      {
        title: "Adesão",
        exhib: false,
      },
    ];
  }else{
    exhibColumn = [
      {
        title: "Nome",
        exhib: columnsNegotiationsAgent.name,
      },
      {
        title: "NPS",
        exhib: columnsNegotiationsAgent.nps,
      },
      {
        title: "CSAT",
        exhib: columnsNegotiationsAgent.csat,
      },
      {
        title: "Enviadas",
        exhib: columnsNegotiationsAgent.sended,
      },
      {
        title: "Respondidas",
        exhib: columnsNegotiationsAgent.answered,
      },
      {
        title: "Adesão",
        exhib: columnsNegotiationsAgent.accession,
      },
    ];
  }

  function chooseDisplay(nameDisplay) {
    const indexFind = exhibColumn.findIndex(
      (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
    );

    if (indexFind === -1) {
      return true;
    }
    return exhibColumn[indexFind].exhib;
  }

  async function getUnityListV3(sourceGrouped, sourceUser, type) {
    const isGroupData = type === "group";
    if (isGroupData) {
      setLoadingGroup(true);
    } else {
      setLoadingUser(true);
    }
    let updatedData = [];
    let response;

    if (type === "group") {
      response = await getUnitGroupedCall(
        format(
          new Date(agentDashboardFilter.initialDateAgenteScreen),
          "yyyy-MM-dd"
        ),
        format(
          new Date(agentDashboardFilter.finalDateAgentScreen),
          "yyyy-MM-dd"
        ),
        agentDashboardFilter.channelSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
        agentDashboardFilter.avaliationSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
        sourceGrouped,
        agentDashboardFilter.groupSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
      );
    } else {
      response = await getUnitUserCall(
        format(
          new Date(agentDashboardFilter.initialDateAgenteScreen),
          "yyyy-MM-dd"
        ),
        format(
          new Date(agentDashboardFilter.finalDateAgentScreen),
          "yyyy-MM-dd"
        ),
        agentDashboardFilter.channelSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
        agentDashboardFilter.avaliationSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
        sourceUser,
        agentDashboardFilter.groupSelectedAgentScreen
          .map((option) => option.id)
          .join(","),
      );
    }

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        if (type === "group") {
          const groupedData = groupBy(data, "idgrupo");
          const hasGroupedData = !!groupedData;
          if (hasGroupedData) {
            for (const id in groupedData) {
              const infosOfGroup = groupedData[id];
              const hasInfosOfGroup = !!infosOfGroup && infosOfGroup.length > 0;
              if (hasInfosOfGroup) {
                let qtde_total_nps = 0;
                let qtde_promotor = 0;
                let qtde_neutro = 0;
                let qtde_detrator = 0;
                let csat_total = 0;
                let qtde_total_csat = 0;

                infosOfGroup.forEach((info) => {
                  const isCsat =
                    info.csat !== null && info.qtde_total_nps === null;
                  if (isCsat) {
                    csat_total = Number(info.csat) ? Number(info.csat) : 0;
                    qtde_total_csat = Number(info.qtde_total_csat)
                      ? Number(info.qtde_total_csat)
                      : 0;
                  }

                  const isNps =
                    info.qtde_total_nps !== null && info.csat === null;
                  if (isNps) {
                    qtde_total_nps = Number(info.qtde_total_nps)
                      ? Number(info.qtde_total_nps)
                      : 0;
                    qtde_promotor = Number(info.qtde_promotor)
                      ? Number(info.qtde_promotor)
                      : 0;
                    qtde_neutro = Number(info.qtde_neutro)
                      ? Number(info.qtde_neutro)
                      : 0;
                    qtde_detrator = Number(info.qtde_detrator)
                      ? Number(info.qtde_detrator)
                      : 0;
                  }
                });

                const hasQtdeTotalNps = !!qtde_total_nps;
                const nps = hasQtdeTotalNps
                  ? ((qtde_promotor - qtde_detrator) / qtde_total_nps) * 100
                  : 0;

                const hasQtdeTotalCsat = !!qtde_total_csat;
                const csat = hasQtdeTotalCsat
                  ? csat_total / qtde_total_csat
                  : 0;

                updatedData.push({
                  id: infosOfGroup[0].idgrupo,
                  name: infosOfGroup[0].grupo,
                  nps: nps.toFixed(2),
                  csat: csat.toFixed(2),
                  qtde_neutro,
                });
              }
            }
          }
        } else {
          const groupedData = groupBy(data, "idusuario");
          const hasGroupedData = !!groupedData;
          if (hasGroupedData) {
            for (const id in groupedData) {
              const infosOfGroup = groupedData[id];
              const hasInfosOfGroup = !!infosOfGroup && infosOfGroup.length > 0;
              if (hasInfosOfGroup) {
                let qtde_total_nps = 0;
                let qtde_promotor = 0;
                let qtde_neutro = 0;
                let qtde_detrator = 0;
                let csat_total = 0;
                let qtde_total_csat = 0;

                infosOfGroup.forEach((info) => {
                  const isCsat =
                    info.csat !== null && info.qtde_total_nps === null;
                  if (isCsat) {
                    csat_total = Number(info.csat) ? Number(info.csat) : 0;
                    qtde_total_csat = Number(info.qtde_total_csat)
                      ? Number(info.qtde_total_csat)
                      : 0;
                  }

                  const isNps =
                    info.qtde_total_nps !== null && info.csat === null;
                  if (isNps) {
                    qtde_total_nps = Number(info.qtde_total_nps)
                      ? Number(info.qtde_total_nps)
                      : 0;
                    qtde_promotor = Number(info.qtde_promotor)
                      ? Number(info.qtde_promotor)
                      : 0;
                    qtde_neutro = Number(info.qtde_neutro)
                      ? Number(info.qtde_neutro)
                      : 0;
                    qtde_detrator = Number(info.qtde_detrator)
                      ? Number(info.qtde_detrator)
                      : 0;
                  }
                });

                const hasQtdeTotalNps = !!qtde_total_nps;
                const nps = hasQtdeTotalNps
                  ? ((qtde_promotor - qtde_detrator) / qtde_total_nps) * 100
                  : 0;

                const hasQtdeTotalCsat = !!qtde_total_csat;
                const csat = hasQtdeTotalCsat
                  ? csat_total / qtde_total_csat
                  : 0;

                updatedData.push({
                  name: infosOfGroup[0].username,
                  nps: nps.toFixed(2),
                  csat: csat.toFixed(2),
                  qtde_neutro,
                });
              }
            }
          }
        }
      }
      const isGroup = type === "group";
      if (isGroup) {
        setDataTotalGroup(updatedData);
        setDataTableGroup(updatedData);
      } else {
        setDataTotalUser(updatedData);
        setDataTableUser(updatedData);
      }

      if (isGroupData) {
        setLoadingGroup(false);
      } else {
        setLoadingUser(false);
      }
    } else {
      const isGroup = type === "group";
      if (isGroup) {
        setDataTotalGroup(updatedData);
        setDataTableGroup(updatedData);
      } else {
        setDataTotalUser(updatedData);
        setDataTableUser(updatedData);
      }

      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          if (isGroupData) {
            setLoadingGroup(false);
          } else {
            setLoadingUser(false);
          }
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  async function refactorNpsList(data) {
    let dataRefactored = [];
    let qtdsGroupsData = [];
    const startDate = format(new Date(agentDashboardFilter.initialDateAgenteScreen), "yyyy-MM-dd");
    const endDate = format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd");
    const idsChannels = agentDashboardFilter.channelSelectedAgentScreen
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join();
    const idsGroups = agentDashboardFilter.groupSelectedAgentScreen
    .map((option) => option.id)
    .join(",")
    const sourceGroups = axios.CancelToken.source()
    const response = await getRankingGroupCall(
      startDate,
      endDate,
      idsChannels,
      idsAvaliation,
      sourceGroups,
      idsGroups
    );
    const responseCsatGrade = await getRankingGroupCallCsat(
      startDate,
      endDate,
      idsChannels,
      idsAvaliation
    );

    const responseTotalSended = await getRankingGroupCallEnviadas(
      startDate,
      endDate,
      idsChannels,
      idsAvaliation,
      idsGroups
    );

    // qtdsGroupsData = [...response.data, ...responseCsatGrade.data];
    qtdsGroupsData = [...response.data];

    data.forEach((datum) => {
      let qtdsSended = responseTotalSended.data.filter(todo => todo.id_grupo === datum.id);
      let qtdsAnswer = responseTotalSended.data.filter(todo => todo.id_grupo === datum.id);
      qtdsSended = qtdsSended.length !== 0 ? qtdsSended[0].qtde_enviada:0
      qtdsAnswer = qtdsAnswer.length !== 0 ? qtdsAnswer[0].qtde_avaliada:0
      
      const caseRefactored = {
        name: {
          data: datum.name,
          config: {
            className: "",
            textEllipsis: false,
          },
        },
        nps: {
          data: Number(datum.nps) ? Number(datum.nps) : 0,
          config: {
            className: "",
            textEllipsis: false,
          },
        },
        csat: {
          data: Number(datum.csat) ? Number(datum.csat) : 0,
          config: {
            className: "",
            textEllipsis: false,
          },
        },
        sended: {
          data: qtdsSended,
          config: {
            className: "",
            textEllipsis: false,
          },
        },
        answered: {
          data: qtdsAnswer,
          config: {
            className: "",
            textEllipsis: false,
          },
        },
        accession: {
          data: qtdsSended
          ? ((qtdsAnswer / qtdsSended) * 100).toFixed(0) + "%"
          : "",
          config: {
            className: "",
            textEllipsis: false,
          },
        },
      };

      dataRefactored.push(caseRefactored);
    });
    console.log("i234i23i4i234i  333", dataRefactored)
    return dataRefactored;
  }

  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data.toLowerCase();
    const objectRowB = rowB.original[columnId].data.toLowerCase();

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;

    return 0;
  }

  function numberSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;

    return 0;
  }

  function handleSearchV2(value) {
    const newDataGroup = dataTotalGroup.filter((datum) => {
      if (
        datum.name.toLowerCase().includes(value.toLowerCase()) ||
        datum.nps.toString().includes(value) ||
        datum.csat.toString().includes(value)
      ) {
        return true;
      } else {
        return false;
      }
    });

    setDataTableGroup(newDataGroup);

    const newDataUser = dataTotalUser.filter((datum) => {
      if (
        datum.name.toLowerCase().includes(value.toLowerCase()) ||
        datum.nps.toString().includes(value) ||
        datum.csat.toString().includes(value)
      ) {
        return true;
      } else {
        return false;
      }
    });

    setDataTableUser(newDataUser);
  }

  columns = [
    {
      Header: "Nome",
      accessor: "name",
      id: "name",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Nome"),
    },
    {
      Header: "NPS",
      accessor: "nps",
      id: "nps",
      sortType: numberSorting,
      disableFilters: true,
      display: chooseDisplay("NPS"),
    },
    {
      Header: "CSAT",
      accessor: "csat",
      id: "csat",
      disableFilters: true,
      sortType: numberSorting,
      display: chooseDisplay("CSAT"),
    },
    {
      Header: "Enviadas",
      accessor: "sended",
      id: "sended",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Enviadas"),
    },
    {
      Header: "Respondidas",
      accessor: "answered",
      id: "answered",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Respondidas"),
    },
    {
      Header: "Adesão",
      accessor: "accession",
      id: "accession",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Adesão"),
    },
  ];

  function renderTable() {
    if (loadingGroup || loadingUser) {
      return <Paperplane />;
    }

    const isGroup = tabActive === "grupos";
    const hasNpsDatasGroup = !!npsDatasGroup && npsDatasGroup.length > 0;
    if (isGroup && hasNpsDatasGroup) {
      return (
        <Table
          className="table-negotiations-call-center"
          data={npsDatasGroup}
          columns={columns}
          fixedHeader
          screen="npsTables"
        />
      );
    }
    if (isGroup && !hasNpsDatasGroup) {
      return (
        <div className="card-table__area-empty">
          <EmptyState />
        </div>
      );
    }

    const isUser = tabActive === "agentes";
    const hasNpsDatasUser = !!npsDatasUser && npsDatasUser.length > 0;
    if (isUser && hasNpsDatasUser) {
      return (
        <Table
          className="table-negotiations-call-center"
          data={npsDatasUser}
          columns={columns}
          fixedHeader
          screen="npsTables"
        />
      );
    }

    if (isUser && !hasNpsDatasUser) {
      return (
        <div className="card-table__area-empty">
          <EmptyState />
        </div>
      );
    }

    return null;
  }

  useEffect(() => {
    const sourceGroup = axios.CancelToken.source();
    const sourceUser = axios.CancelToken.source();

    if (!!agentDashboardFilter) {
      getUnityListV3(sourceGroup, sourceUser, "group");
      getUnityListV3(sourceGroup, sourceUser, "ungroup");
    }

    return () => {
      sourceGroup.cancel("Operation canceled by the user. (sourceGroup)");
      sourceUser.cancel("Operation canceled by the user. (sourceUser)");
    };
  }, [agentDashboardFilter]);

  useEffect(() => {
    if (!searchData) {
      setDataTableUser(dataTotalUser);
      setDataTableGroup(dataTotalGroup);
    }
  }, [searchData]);

  return (
    <div>
      {cardsOfCallCenterDash.card13 && (
        <section className="negotiations">
          <div className="negotiations-card">
            <header className="negotiations-card-header negotiations-call-center-card-header">
              <div className="negotiations-card-header__content">
                <h6>{`NPS e CSAT por ${
                  tabActive === "grupos" ? "grupo" : "atendente"
                }`}</h6>
                <div className="negotiations-card-header__content__input">
                  <InputSearch
                    search={searchData}
                    setSearch={setSearchData}
                    // handleClick={(e) => handleSearch(searchData)}
                    onSearch={(e) => handleSearchV2(searchData)}
                    onKeyDown={true}
                  />
                </div>
                <div className="negotiations-card-header__content__filter">
                  <PopoverColumnsFilter
                    className={"filters-columns"}
                    placement="bottom-end"
                    menuData={exhibColumn}
                    screen="quality_agent_negotiations"
                  >
                    <div className="email__container-subheader__actionsTwo">
                      <ColumnFilterIcon />
                      <span className="email__container-subheader__actionsTwo-span">
                        Colunas
                      </span>
                    </div>
                  </PopoverColumnsFilter>
                </div>
              </div>
            </header>
            <div className="filter-and-caption__tabs">
              <div className="table-groups">
                <button
                  className={`button-tabs ${
                    tabActive === "grupos" ? "active" : ""
                  }`}
                  onClick={() => {
                    setTabActive("grupos");
                  }}
                >
                  <div className="button-tabs__text">
                    <h2 className="button-tabs__text__h5">Grupos</h2>
                  </div>
                </button>

                <button
                  className={`button-tabs ${
                    tabActive === "agentes" ? "active" : ""
                  }`}
                  onClick={() => {
                    setTabActive("agentes");
                  }}
                >
                  <div className="button-tabs__text">
                    <h2 className="button-tabs__text__h5">Atendentes</h2>
                  </div>
                </button>
              </div>

              <span className="division" />
            </div>

            <div className="trading-table-container">{renderTable()}</div>
          </div>
        </section>
      )}
    </div>
  );
}
